(function () {
  const root = window.Shopify && Shopify.routes && Shopify.routes.root
    ? Shopify.routes.root
    : '/';

  function getLocale(element) {
    return (
      element?.dataset?.locale ||
      document.documentElement.lang ||
      'es-ES'
    );
  }

  function formatMoney(cents, currency, locale) {
    const value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(locale || 'es-ES', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(value);
    } catch (error) {
      return value.toFixed(2) + ' €';
    }
  }

function updateProgressElements(cart) {
  const elements = document.querySelectorAll('[data-free-shipping-progress]');

  elements.forEach((element) => {
    const threshold = Number(element.dataset.threshold || 10000);
    const total = Number(cart.total_price || 0);
    const itemCount = Number(cart.item_count || 0);
    const remaining = Math.max(threshold - total, 0);
    const progress = Math.min(Math.max((total / threshold) * 100, 0), 100);

    const currency = cart.currency || element.dataset.currency || 'EUR';
    const locale = getLocale(element);

    const message = element.querySelector('[data-fs-message]');
    const bar = element.querySelector('[data-fs-bar]');
    const isTopbar = element.dataset.fsLayout === 'topbar';

    if (bar) {
      bar.style.width = progress + '%';
    }

    if (!message) return;

    if (isTopbar) {
      if (itemCount === 0) {
        message.innerHTML = `¡ENVÍO GRATIS EN PEDIDOS SUPERIORES A ${formatMoney(threshold, currency, locale)}!`;
      } else if (remaining > 0) {
        message.innerHTML = `¡ESTÁS A SÓLO ${formatMoney(remaining, currency, locale)} DE OBTENER ENVÍO GRATIS!`;
      } else {
        message.innerHTML = `¡YA TIENES ENVÍO GRATIS!`;
      }

      return;
    }

    if (remaining > 0) {
      message.innerHTML = `
        <strong> ¡ESTÁS A SÓLO ${formatMoney(remaining, currency, locale)} DE OBTENER ENVÍO GRATIS!</strong>
      `;
    } else {
      message.innerHTML = `
        <strong>¡Ya tienes envío gratis!</strong>
        <span>Tu pedido supera el mínimo para envío gratuito.</span>
      `;
    }
  });
}

  function updateCartCount(cart) {
    const count = cart.item_count || 0;
    const bubbles = document.querySelectorAll('.cart-count-bubble');

    bubbles.forEach((bubble) => {
      const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
      const hiddenSpan = bubble.querySelector('.visually-hidden');

      if (visibleSpan) {
        visibleSpan.textContent = count;
      }

      if (hiddenSpan) {
        hiddenSpan.textContent = count + ' artículos';
      }
    });
  }

  function refreshCartProgress() {
    return fetch(root + 'cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((cart) => {
        updateProgressElements(cart);
        updateCartCount(cart);
        return cart;
      })
      .catch((error) => {
        console.warn('No se ha podido actualizar la barra de envío gratis:', error);
      });
  }

function addVariantToCart(variantId, button) {
  if (!variantId || !button) return;

  const originalText = button.textContent;
  const cartDrawer = document.querySelector('cart-drawer');
  const cartNotification = document.querySelector('cart-notification');
  const cartElement = cartDrawer || cartNotification;

  button.classList.add('is-loading');
  button.textContent = 'Añadiendo...';

  const body = {
    items: [
      {
        id: Number(variantId),
        quantity: 1
      }
    ]
  };

  /*
   * Esto es lo importante:
   * Si existe el cart drawer de Dawn, pedimos las secciones que necesita
   * para actualizar productos, subtotal, contador, botones, etc.
   */
  if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
    body.sections = cartElement.getSectionsToRender().map((section) => section.id);
    body.sections_url = window.location.pathname;

    if (typeof cartElement.setActiveElement === 'function') {
      cartElement.setActiveElement(document.activeElement);
    }
  }

  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        throw new Error(data.description || 'Error al añadir el producto');
      }

      /*
       * Aquí actualizamos visualmente el cart drawer de Dawn.
       * Esto debería actualizar también el subtotal/precio del carrito.
       */
      if (
        cartElement &&
        data.sections &&
        typeof cartElement.renderContents === 'function'
      ) {
        cartElement.renderContents(data);
      }

      return refreshCartProgress();
    })
    .then(() => {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = 'Añadido';

      setTimeout(() => {
        button.classList.remove('is-added');
        button.textContent = originalText;
      }, 1600);
    })
    .catch((error) => {
      console.error(error);

      button.classList.remove('is-loading');
      button.textContent = 'Error';

      setTimeout(() => {
        button.textContent = originalText;
      }, 1600);
    });
}
  function shuffleArray(array) {
    const shuffled = array.slice();

    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = shuffled[i];
      shuffled[i] = shuffled[j];
      shuffled[j] = temp;
    }

    return shuffled;
  }

  function initRandomUpsellCarousels() {
    const carousels = document.querySelectorAll('[data-fs-random-upsell]');

    carousels.forEach((carousel) => {
      if (carousel.dataset.fsReady === 'true') return;

      carousel.dataset.fsReady = 'true';

      const track = carousel.querySelector('[data-fs-track]');
      const prev = carousel.querySelector('[data-fs-prev]');
      const next = carousel.querySelector('[data-fs-next]');
      const maxSlides = Number(carousel.dataset.maxSlides || 8);

      if (!track) return;

      let slides = Array.from(track.querySelectorAll('[data-fs-slide]'));

      if (!slides.length) {
        carousel.hidden = true;
        return;
      }

      const shuffledSlides = shuffleArray(slides);

      track.innerHTML = '';

      shuffledSlides.slice(0, maxSlides).forEach((slide) => {
        track.appendChild(slide);
      });

      slides = Array.from(track.querySelectorAll('[data-fs-slide]'));

      if (slides.length <= 1) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
      }

      let index = 0;

      function goTo(newIndex) {
        if (!slides.length) return;

        if (newIndex < 0) {
          index = slides.length - 1;
        } else if (newIndex >= slides.length) {
          index = 0;
        } else {
          index = newIndex;
        }

        track.style.transform = `translateX(-${index * 100}%)`;
      }

      if (prev) {
        prev.addEventListener('click', () => goTo(index - 1));
      }

      if (next) {
        next.addEventListener('click', () => goTo(index + 1));
      }

      if (carousel.dataset.autoplay === 'true' && slides.length > 1) {
        setInterval(() => {
          goTo(index + 1);
        }, 10000);
      }

      goTo(0);
    });
  }

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest('[data-fs-add-to-cart]');

    if (addButton) {
      event.preventDefault();
      addVariantToCart(addButton.dataset.variantId, addButton);
      return;
    }

    if (
      event.target.closest('cart-remove-button') ||
      event.target.closest('.cart-remove-button') ||
      event.target.closest('.quantity__button')
    ) {
      setTimeout(refreshCartProgress, 900);
    }
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.closest('cart-items') ||
      event.target.closest('cart-drawer-items')
    ) {
      setTimeout(refreshCartProgress, 900);
    }
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (form && form.matches('form[action*="/cart/add"]')) {
      setTimeout(refreshCartProgress, 900);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    refreshCartProgress();
    initRandomUpsellCarousels();
  });

  document.addEventListener('shopify:section:load', function () {
    refreshCartProgress();
    initRandomUpsellCarousels();
  });
})();